/* eslint-disable */

import { grey } from '@material-ui/core/colors';
import * as themeConstants from '../../Constants/Theme/Theme.constants';
import Colors from '../../Support/Theme/Colors/Colors';

const bannerTipsHeight = 130;

/**
 * Create styles for `<PlaceOrder />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<PlaceOrder />` styles
 */
const placeOrderStyles = ({ theme }) => {
  return {
    paperClasses: {
      maxHeight: `40%`,
    },
    paperClassesSuccess: {
      height: `auto`,
      maxWidth: 700,
    },
    checkIcon: {
      fontSize: 90,
    },
    dropDown: {},
    dropdownIcon: {
      fontSize: theme.spacing(1) * 2.8,
      marginRight: theme.spacing(1) * 1.5,
      marginBottom: -theme.spacing(1) / 2,
      opacity: 0.6,
    },
    calendarIcon: {
      opacity: 0.6,
      paddingRight: theme.spacing(1) / 2,
    },
    heading: {
      color: Colors.boralgreen[500],
    },
    disabledDate: {
      opacity: 0.38,
      '&:hover button': {
        cursor: `default`,
        backgroundColor: `transparent`,
      },
    },
    errorList: {
      paddingLeft: theme.spacing(1) * 3,
    },
    errorListItem: {
      color: Colors.california[900],
    },
    errorBox: {
      border: `1px solid ${Colors.california[900]}`,
      backgroundColor: `#fff`,
      color: Colors.california[900],
      padding: theme.spacing(1) * 1.5,
      margin: theme.spacing(1) / 4,
    },
    errorText: {
      color: Colors.california[900],
    },
    mandatoryFieldError: {
      color: theme.palette.error.main,
      opacity: 1,
    },
    orderConfirmStatusError: {
      border: `2px solid ${theme.palette.error.main}`,
    },
    helperText: {
      color: `inherit`,
      cursor: `pointer`,
      textDecoration: `underline`,
      lineHeight: `1.1rem`,
    },
    today: {
      border: `1px solid ${grey[300]}`,
      display: `inline-block`,
    },
    timeSelector: {
      maxHeight: `80%`,
      maxWidth: 600,
      minWidth: 550,
    },
    timerButtonIcon: {
      marginRight: theme.spacing(1),
    },
    helpLink: {
      marginTop: theme.spacing(1) * 3,
      color: `inherit`,
      textDecoration: `underline`,
      cursor: `pointer`,
    },
    themeOverline: {
      ...theme.typography.overline,
      margin: 0,
    },
    placeOrderButtons: {
      marginBottom: 200,
    },
    itemIcon: {
      marginRight: theme.spacing(1) * 2,
      opacity: 0.5,
    },
    testIcon: {
      marginRight: theme.spacing(1) * 2,
      marginTop: theme.spacing(1) / 2,
      opacity: 0.5,
    },
    helpIcon: {
      left: -theme.spacing(1) / 2,
      top: theme.spacing(1) * 0.7,
      position: `relative`,
      color: themeConstants.BORAL_GREEN,
      cursor: `pointer`,
    },
    menuItem: {
      height: `auto`,
    },
    root: {
      padding: theme.spacing(1) * 2,
    },
    confirmedChip: {
      backgroundColor: Colors.montecarlo[900],
    },
    toBeConfirmedChip: {
      backgroundColor: Colors.california[900],
    },
    phoneHelperText: {
      marginTop: 0,
    },
    confirmCopy: {
      width: `100%`,
    },
    greyChip: {
      color: grey[700],
      backgroundColor: grey[300],
    },
    paperClassesReview: {
      paddingBottom: theme.spacing(1) * 4,
    },
    separator: {
      border: 0,
      height: 1,
      backgroundColor: grey[300],
      width: `100%`,
    },
    separatorTips: {
      marginLeft: theme.spacing(1) * 2,
      marginTop: theme.spacing(1) * 2,
      marginBottom: theme.spacing(1) * 2,
      height: 1,
      backgroundColor: grey[300],
      maxWidth: 244,
    },
    pageTips: {
      ...theme.typography.body2,
      position: `fixed`,
      top: 90,
      right: 30,
      color: themeConstants.BORAL_GREEN,
      [theme.breakpoints.down(`xs`)]: {
        display: `none`,
      },
    },
    pageTipsIcon: {
      display: `inline-block`,
      position: `relative`,
      top: 2,
      marginRight: theme.spacing(1),
    },
    pageTipsMobile: {
      position: `fixed`,
      bottom: 40,
      right: -14,
      borderRadius: 4,
      padding: `3px 20px 2px 5px`,
      color: themeConstants.BORAL_GREEN,
      boxShadow: theme.shadows[4],
      backgroundColor: `white`,
      transition: `0.5s all`,
      cursor: `pointer`,
      '&:hover': {
        right: -4,
      },
      zIndex: 1201,
      [theme.breakpoints.up(`sm`)]: {
        display: `none`,
      },
    },
    pageTipsTitle: {
      color: themeConstants.BORAL_GREEN,
    },
    drawer: {
      padding: `0 ${theme.spacing(1) * 2}px`,
      marginTop: theme.spacing(1) * 2,
      minHeight: 30,
    },
    drawerContent: {
      width: 300,
      paddingLeft: theme.spacing(1) * 2,
      paddingRight: theme.spacing(1) * 2,
      display: `block`, // we need to change it as ios safari fails to layout properly
    },
    feedback: {
      paddingBottom: 200,
    },
    drawerClose: {
      marginTop: -20,
      position: `relative`,
      top: 10,
    },
    fakeBulletPoint: {
      paddingRight: 15,
      display: `inline-block`,
      marginLeft: -18,
      width: 0,
    },
    tipsList: {
      listStyleType: `none`,
      margin: 0,
      paddingLeft: 20,
    },
    drawerPaper: {
      overflowX: `hidden`,
      top: theme.spacing(1) * 7,
    },
    callBoral: {
      color: themeConstants.BORAL_GREEN,
    },
    feedbackLink: {
      color: themeConstants.BORAL_GREEN,
      textDecoration: `underline`,
      cursor: `pointer`,
    },
    bannerTipsIcon: {
      position: `relative`,
      top: 2,
    },
    bannerTips: {
      display: `block`,
      height: bannerTipsHeight,
      marginLeft: -theme.spacing(1) * 3,
      marginTop: -theme.spacing(1) * 3,
      width: `inherit`,
      position: `fixed`,
      backgroundColor: `white`,
      zIndex: 1,
      overflow: `hidden`,
      [theme.breakpoints.up(`sm`)]: {
        height: bannerTipsHeight,
      },
    },
    underBannerTipsPadding: {
      [theme.breakpoints.down(`sm`)]: {
        paddingTop: bannerTipsHeight + 20,
      },
    },
    withEllipsis: {
      textOverflow: `ellipsis`,
      /* width: 100%; */
      display: `block`,
      overflow: `hidden`,
    },
    confirmWidth: {
      alignItems: `flex-start`,
      marginTop: -theme.spacing.unit,
      marginBottom: theme.spacing.unit,
    },
    radioButton: {
      position: `relative`,
      top: theme.spacing.unit,
    },
    formControl: {
      width: `100%`,
    },
  };
};

export default placeOrderStyles;
